export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBD72FZGoCfn_UjLYXhRz7kJIRVA4XORDk',
    authDomain: 'ihg-bef-online.firebaseapp.com',
    databaseURL: 'https://ihg-bef-online.firebaseio.com',
    projectId: 'ihg-bef-online',
    storageBucket: 'ihg-bef-online.appspot.com',
    messagingSenderId: '90031745353',
    appId: '1:90031745353:web:d33e3fd6a89f06df',
  },
  names: {
    bef: 'Labour Standards',
    befFull: 'WO Labour Standards',
    befShort: 'LS',
    scheduler: 'Team Planner',
    schedulerFull: 'WO Team Planner',
    schedulerShort: 'TP',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
